import * as React from "react";
import { PageHeading } from "./PageHeading";
import { IRioResource } from "rio.react.all";

interface IPageProps {
    heading: IRioResource;
}

export class Page extends React.Component<IPageProps> {
    render(): Object | string | number | {} | Object | Object | boolean {
        return (
            <React.Fragment>
                <section className="heading">
                    <PageHeading resource={this.props.heading} />
                </section>
                <section className="content">
                    {this.props.children}
                </section>
            </React.Fragment>
        );
    }
}